export default __webpack_public_path__ + "static/UD-horiz-65e4318cba6fd901b9be45f6892f9141.svg";